import { useEffect } from "react";
import { robotsFor } from "@/lib/robots";

const SITE = "Readoo";
const DEFAULT_DESC =
  "Tutto quello che vale la pena sapere, senza rumore. Leggi le notizie, scopri nuovi contenuti, completa le sfide e accumula premi. Informati. Gioca. Vinci.";
const DEFAULT_TITLE = "Readoo - L'informazione che ti premia";
// Monolingua (italiano): nessun hreflang, inLanguage fisso.
const IN_LANGUAGE = "it-IT";
const OG_LOCALE = "it_IT";
export function SEO({ title, rawTitle, description, image, type = "website", publishedTime, modifiedTime, url, jsonLd }) {
  useEffect(() => {
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    const pageUrl = url || (typeof window !== "undefined" ? window.location.href.split("#")[0] : origin);
    const defaultImage = `${origin}/og-default.png`;
    const img = image || defaultImage;
    const fullTitle = rawTitle || (title ? `${title} | ${SITE}` : DEFAULT_TITLE);
    const desc = description || DEFAULT_DESC;

    document.title = fullTitle;

    const setMeta = (attr, key, val) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!val) {
        if (el) el.remove();
        return;
      }
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", val);
    };
    const setLink = (rel, href) => {
      let el = document.head.querySelector(`link[rel="${rel}"]`);
      if (!href) return;
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    // Google / standard
    setMeta("name", "description", desc);
    setMeta("name", "robots", robotsFor(window.location.pathname));
    setLink("canonical", pageUrl);

    // Open Graph
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", SITE);
    setMeta("property", "og:url", pageUrl);
    setMeta("property", "og:locale", OG_LOCALE);
    setMeta("property", "og:image", img);
    setMeta("property", "og:image:secure_url", img);
    setMeta("property", "og:image:alt", title || SITE);

    // Article-specific
    setMeta("property", "article:published_time", type === "article" ? publishedTime : null);
    setMeta("property", "article:modified_time", type === "article" ? (modifiedTime || publishedTime) : null);

    // Twitter
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", img);

    // Structured data (schema.org JSON-LD)
    let ld = document.head.querySelector('script[type="application/ld+json"]#ld-json');
    if (!ld) {
      ld = document.createElement("script");
      ld.setAttribute("type", "application/ld+json");
      ld.setAttribute("id", "ld-json");
      document.head.appendChild(ld);
    }
    const graph = jsonLd || {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": SITE,
      "url": origin,
      "inLanguage": IN_LANGUAGE,
      "publisher": {
        "@type": "Organization",
        "name": SITE,
        "logo": { "@type": "ImageObject", "url": `${origin}/readoo-icon.png` },
      },
    };
    ld.textContent = JSON.stringify(graph);
  }, [title, rawTitle, description, image, type, publishedTime, modifiedTime, url, jsonLd]);

  return null;
}
